module.exports = __webpack_public_path__ + "static/media/KaTeX_Typewriter-Regular.35fe2cce.ttf";